import { useFormContext } from 'react-hook-form';
import { JsonInputRenderer } from '../../../UI/JsonForm/JsonInputRenderer';
import { PartTitle } from '../../PartTitle';
import { ApplicationPreview } from '../ApplicationPreview';
import type { ApplicationFormStep } from '../types';

interface ApplicationFromSectionsProps {
  step: Omit<ApplicationFormStep, 'icon'>;
  currentStep: number;
}
const ApplicationFormSections = (props: ApplicationFromSectionsProps) => {
  const { step, currentStep } = props;
  const { title = '', sections = [], component: Component, isReview = false } = step;
  const { watch } = useFormContext();
  const values = watch();

  if (isReview) {
    return <ApplicationPreview />;
  }
  if (Component) {
    return <Component />;
  }
  return (
    <>
      <div className='col-span-12'>
        <PartTitle title={title} />
      </div>
      {sections.map((section) => (
        <JsonInputRenderer section={section} key={section.id} formValues={values} currentStep={currentStep} />
      ))}
    </>
  );
};

export default ApplicationFormSections;
